module.exports = __webpack_public_path__ + "img/generator1.c0afb9a2.png";